import React from 'react'
import NotFound from 'src/containers/NotFound'
import { useLocation } from 'react-router-dom'
import ApplicationArea from 'src/containers/Application'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { ApplicantApplicationState } from 'src/redux/slices/Application'
import { FetchStatus } from '@flatsy/types/FetchStatus'
import QualificationForm from 'src/containers/Qualification'
import ShowFailure from 'src/containers/Failure'
import { useParams } from 'react-router'
import { ApplicationState, FrontApplicationState } from '@flatsy/types/Applications/Status'
import { ApplicationBookingState } from '@flatsy/types/Applications'
import Cancelled from 'src/containers/Application/Booking/Cancelled'
import Cancel from 'src/containers/Application/Booking/Cancel'

const useQuery = () => new URLSearchParams(useLocation().search)

const ApplicationRouter: React.FC = (): React.ReactElement => {
  const { application } = useApplicationDetails()
  const current = application.application
  const { applicationId } = useParams<{
    applicationId: string
  }>()
  const getIsInterest = useQuery().get('interest')

  if (
    current.state === ApplicationState.REFUSED ||
    current.state === ApplicationState.ABANDONED ||
    current.state === ApplicationState.ACCEPTED
  ) {
    return <Cancelled />
  }

  // if (
  //   ((current.state === ApplicationState.REFUSED || current.state === ApplicationState.ABANDONED) &&
  //     current.booking_state === ApplicationBookingState.UNAUTHORIZED) ||
  //   (current.state === ApplicationState.ACCEPTED && ApplicationBookingState.CONFIRMED)
  // ) {
  //   return <Cancelled />
  // }

  if (
    current.booking_state === ApplicationBookingState.COMPLETED &&
    current.computedState === ApplicationState.QUALIFYING &&
    current.state === ApplicationState.QUALIFYING &&
    getIsInterest === 'false'
  ) {
    return <Cancel />
  }

  const isNotFound = (application: ApplicantApplicationState): boolean => {
    return (
      application.getStatus === FetchStatus.FAILED ||
      application.getStatus === FetchStatus.NOT_FOUND
    )
  }

  if (isNotFound(application)) {
    return <NotFound />
  }

  if (
    (current.computedState === FrontApplicationState.SUCCESS ||
      current.computedState === FrontApplicationState.WAITING_LIST) &&
    !application.justCompleted &&
    applicationId
  ) {
    return <ApplicationArea />
  }

  if (
    current.state === ApplicationState.UNQUALIFIED &&
    current.booking_state !== ApplicationBookingState.UNAUTHORIZED &&
    applicationId
  ) {
    return <ApplicationArea />
  }

  if (current.computedState === FrontApplicationState.FAILED && !application.justCompleted) {
    return <ShowFailure />
  }

  return <QualificationForm />
}

export default ApplicationRouter
